import React, {useEffect, useState} from 'react';
import {get} from '../../api/api';
import './styles.scss';
import * as fonts from '../../util/fonts';
import {strings} from '../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppSpinner from '../../components/app-spinner';
import {setWizard} from '../../store/actions';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import {
  uriGetServiceDetails,
  uriGetServices,
  uriGetServicesBO,
} from '../../api/endpoints';
import Bubble from './bubble';
import MyServicesResponsive from './my-services-responsive';
import ServiceDetailsModal from './service-details-modal';
import ModalTemplate from '../../components/modal';
import colors from '../../util/colors';
import AuthorizedImage from '../../components/images';
import {useHistory} from 'react-router-dom';

// ir buscar strings ao BO
const labels = strings.pt.services;

interface MyServicesProps {
  user: any;
  titular?: any;
  selectedBu: any;
  availableBus?: any;
  wizard?: any;
  buStyles: any;
  setWizard?(value: any): void;
  labels?: typeof strings.pt.services;
}

const featureName = 'MyServices';

function MyServices({selectedBu, labels, buStyles, user}: MyServicesProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const history = useHistory();

  function getWindowWidth() {
    const {innerWidth: width} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  const [showError, setShowError] = useState(false);
  const [show, setShow] = useState(false);
  const [services, setServices] = useState<any[]>([]);
  const [servicesDigital, setServicesDigital] = useState<any[]>([]);
  const [servicesPhysical, setServicesPhysical] = useState<any[]>([]);
  const [serviceDetails, setServiceDetails] = useState<any>();
  const [loadingInfo, setLoadingInfo] = useState<any>(true);

  useEffect(() => {
    const getServices = async () => {
      try {
        await get(
          uriGetServices(selectedBu.buId, selectedBu.prdNbr, selectedBu.benNbr),
          false,
          0,
          featureName
        ).then((res: any) => {
          // const filtered = res?.data?.items?.filter(
          //   (el: any) => !el.isMedicoOnline
          // );
          // setServices(filtered);
          const digital = res?.data?.items?.filter(
            (el: any) => el.isDigitalService || el.isMedicoOnline
          );
          const physical = res?.data?.items?.filter(
            (el: any) => !el.isDigitalService && !el.isMedicoOnline
          );
          setServicesDigital(digital);
          setServicesPhysical(physical);
          setServices(res?.data?.items);
        });
      } catch (err: any) {
        setShowError(true);
      } finally {
        setLoadingInfo(false);
      }
    };
    const getServicesNC = async () => {
      try {
        const finalServices: any[] = [];
        const services: any =
          (await get(uriGetServicesBO(), false, 0, featureName).catch(() => {
            setShowError(true);
          })) || [];
        const activeServices = services?.data?.items?.filter(
          (service: any) =>
            service.status === 'ACTIVE' && service.buAlias === 'NOTCLIENT'
        );
        activeServices.forEach((el: any) => {
          finalServices.push({
            ...el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ),
            serviceId: el.id,
            alias: el.alias,
            displayText: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).serviceName,
            image: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).image,
            listDescription: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).listDescription,
            listDescriptionAPP: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).listDescriptionApp,
            serviceName: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).serviceName,
            isMedicoOnline: el.isMedicoOnline,
            buttonText: el.buServiceDetails.find(
              (detail: any) => detail.languageAlias === user.language
            ).buttonText,
          });
          // const filtered = finalServices.filter(
          //   (el: any) => !el.isMedicoOnline
          // );
          // setServices(filtered);
          const digital = finalServices.filter(
            (el: any) => el.isDigitalService || el.isMedicoOnline
          );
          const physical = finalServices.filter(
            (el: any) => !el.isDigitalService && !el.isMedicoOnline
          );
          setServicesDigital(digital);
          setServicesPhysical(physical);
          setServices(finalServices);
        });
      } catch (e: any) {
      } finally {
        setLoadingInfo(false);
      }
    };
    setLoadingInfo(true);
    if (selectedBu.buId === 'NOTCLIENT') {
      getServicesNC();
    } else {
      getServices();
    }
  }, [selectedBu.memId]);

  const retrieveServiceDetails = async (
    serviceId: any,
    isMedicoOnline: boolean
  ) => {
    if (isMedicoOnline) {
      history.push('/consultas-online');
    } else {
      try {
        await get(uriGetServiceDetails(serviceId), false, 0, featureName).then(
          (details: any) => {
            setServiceDetails(details?.data);
            if (details?.data?.bubbleBehavior === 'link') {
              const bubbleUrl = details?.data?.buServiceDetails.find(
                (detail: any) => detail.languageAlias === user.language
              )?.bubbleUrl;
              if (bubbleUrl) {
                const win = window.open(bubbleUrl, '_blank');
                if (win != null) {
                  win.focus();
                }
              }
            }
          }
        );
      } catch (err: any) {
        setShowError(true);
      }
    }
  };

  return (
    <>
      <Column className="my-services-container">
        <Row className="my-services-titlerow my-services-row">
          <Column className="my-services-titlecolumn">
            <Header1
              className="my-services-heading1"
              style={{...fonts.XL, ...fonts.Bold}}>
              {labels?.services_title}
            </Header1>
            <div style={{...fonts.M}}>{labels?.services_mainSubtitle}</div>
          </Column>
        </Row>
        {services && services.length > 0 && servicesDigital.length === 0 && (
          <Row className="my-services-more-services-available-title">
            <p style={{...fonts.M}}>
              {labels?.services_noDigitalServicesAvailable}
            </p>
          </Row>
        )}
        {windowWidth > 768 ? (
          loadingInfo ? (
            <AppSpinner
              style={{
                width: 'fit-content',
                margin: 'auto',
                marginTop: '5%',
                marginBottom: '10%',
              }}
            />
          ) : (
            <Row className="my-services-row-images-container">
              {services && services.length === 0 && (
                <Row className="my-services-more-services-available-title">
                  <p style={{...fonts.M}}>
                    {labels?.services_noServicesAvailable}
                  </p>
                </Row>
              )}

              {servicesDigital &&
                servicesDigital.length !== 0 &&
                Object.keys(servicesDigital).map((key: any, index: number) => {
                  if (
                    servicesDigital[key]?.isDigitalService ||
                    servicesDigital[key]?.isMedicoOnline
                  ) {
                    return (
                      <Row
                        key={index}
                        className={
                          index === servicesDigital.length - 1 &&
                          servicesDigital.length % 2 === 1
                            ? 'my-services-row-images-display-odd'
                            : 'my-services-row-images-display'
                        }
                        onClick={() => {
                          retrieveServiceDetails(
                            servicesDigital[key]?.serviceId,
                            servicesDigital[key]?.isMedicoOnline
                          );
                          setShow(true);
                        }}>
                        <Bubble classNames={'my-services-bubble-image'} />
                        <AuthorizedImage
                          source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${servicesDigital[key].image}`}
                          className={
                            servicesDigital[key]?.isMedicoOnline
                              ? 'my-services-images-mo'
                              : 'my-services-images'
                          }
                        />
                        <Column className="my-services-service-info">
                          <p
                            style={{
                              ...fonts.Bold,
                              ...fonts.L,
                              color: buStyles?.primaryColor,
                            }}
                            className="my-services-service-info-p">
                            {servicesDigital[key].serviceName}
                          </p>
                          <p
                            style={{...fonts.M}}
                            className="my-services-service-info-p">
                            {servicesDigital[key].listDescription}
                          </p>
                        </Column>
                      </Row>
                    );
                  }
                })}
              {services && services.length !== 0 && (
                <Row className="my-services-more-services-available-container ">
                  <Row className="my-services-more-services-available-title">
                    <p style={{...fonts.M}}>{labels?.services_subTitle}</p>
                  </Row>

                  {Object.keys(servicesPhysical).map(
                    (key: any, index: number) => {
                      if (
                        !servicesPhysical[key]?.isDigitalService &&
                        !servicesPhysical[key]?.isMedicoOnline
                      )
                        return (
                          <Row
                            key={index}
                            className="my-services-more-services-available-list-container">
                            <Row
                              className="my-services-more-services-available-list"
                              onClick={() => {
                                retrieveServiceDetails(
                                  servicesPhysical[key]?.serviceId,
                                  servicesPhysical[key]?.isMedicoOnline
                                );
                                setShow(true);
                              }}>
                              <p
                                style={{
                                  ...fonts.Bold,
                                  ...fonts.ML,
                                  color: buStyles?.primaryColor,
                                }}
                                className="my-services-service-info-p">
                                {servicesPhysical[key].serviceName}
                              </p>
                              <p
                                style={{...fonts.M}}
                                className="my-services-service-info-p">
                                {servicesPhysical[key].listDescription}
                              </p>
                            </Row>
                          </Row>
                        );
                    }
                  )}
                </Row>
              )}
            </Row>
          )
        ) : (
          <MyServicesResponsive
            setShowError={setShowError}
            setShow={setShow}
            retrieveServiceDetails={retrieveServiceDetails}
            services={services}
          />
        )}
      </Column>
      <ServiceDetailsModal
        show={show}
        setShow={setShow}
        serviceDetails={serviceDetails}
      />
      <ModalTemplate
        type="error"
        show={showError}
        onHide={() => setShowError(false)}
        hideFooter={true}
        cross={true}>
        <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
          {labels?.services_error}
        </p>{' '}
      </ModalTemplate>
    </>
  );
}

const mapStateToProps = ({selectedBu, strings, globalStyles, user}: any) => ({
  selectedBu: selectedBu.value,
  labels: strings.value.pt.services,
  buStyles: globalStyles.value,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MyServices)
);
